const url = "https://itiqpro.com"
const formUrl = "https://form.itiqpro.com/"
const purchaseSuccessUrl = "/purchase-thanks"
const purchaseCancelUrl = "/purchase"
const bookSuccessUrl = "/book-thanks"
const bookCancelUrl = "/book"

export { url, formUrl, purchaseSuccessUrl, purchaseCancelUrl, bookSuccessUrl, bookCancelUrl }